module.exports = __webpack_public_path__ + "housingStatic/img/zhrq.3a7413b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_png/zhrq.png
// module id = 9HnW
// module chunks = 2